module.exports = __webpack_public_path__ + "static/media/Bailey Corner Wardrobe (3).742120a6.jpg";